// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__WNzHk","input":"style_input__BkBcH"};